<template>
  <!-- 订单详情 -->
  <div class="order-detail">
    <div class="order-detail-wrapper">
      <div class="title-left">
        <div class="icon" @click="handleBack">
          <img class="back-icon" src="../../../assets/image/reback.svg" alt=""/>
        </div>
        <div class="order-info">
          <img
            class="order-img"
            :src="imageUrl"
            alt=""
          />
          <div class="order-info-box">
            <div class="order-title">
              <div class="case-text">{{ detailInfo.orderName }}</div>
              <template v-if="platform === 'designerService' && curTransferState.value">
                <div class="order-status" :class="curTransferState.class">{{ curTransferState.label || '' }}</div> 
              </template>
              <template v-else>
                <div v-if="detailInfo.orderState === 'waitAccept' || detailInfo.orderState === 'inDesign' || detailInfo.orderState === 'waitDesign'"  class="order-status blue-color">{{ $t( `design.order.${detailInfo.orderState}` ) }}</div> 
                <div v-if="detailInfo.orderState === 'waitCheck'" class="order-status green-color">{{ $t( `design.order.${detailInfo.orderState}` ) }}</div> 
                <div v-if="detailInfo.orderState === 'pause' || detailInfo.orderState === 'waitRecover' || detailInfo.orderState === 'waitRedesign'" class="order-status red-color">{{ $t( `design.order.${detailInfo.orderState}` ) }}</div> 
                <div v-if="detailInfo.orderState === 'cancel' || detailInfo.orderState === 'complete' || detailInfo.orderState ==='redesignComplete'" class="order-status gray-color">{{ $t( `design.order.${detailInfo.orderState}` ) }}</div> 
              </template>
            </div>
            <div class="order-title">
              <div class="info-box">
                <img src="../../../assets/image/type_icon.svg" alt="" />
                <span class="info-text"
                  >{{ detailInfo.typeName }}-<span class="text-color">{{ detailInfo.productName }}</span></span
                >
              </div>
              <div class="info-box">
                <img class="user-icon" src="../../../assets/image/user_icon.svg" alt=""/>
                <span class="info-text"
                  >{{$t('design.creator') || "创建人"}}-<span class="text-color">{{ detailInfo.createBy }}</span></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="title-right">
        <img
          class="chat-icon"
          src="../../../assets/image/chat_icon.svg"
          alt=""
        />
        <img src="../../../assets/image/download_icon.svg" alt="" />
      </div> -->
    </div>

    <div class="order-detail-main">
      <xl-tabs class="info-tabs" v-model="activeTab" :tabLists="tabList" @tab-click="handleClick">
        <!-- 案例详情 -->
        <template #caseDetail>
          <caseDetail :orgID="orgID" :orderID="orderID" :info="detailInfo" :platform="platform"></caseDetail>
        </template>
        <!-- 影像数据 -->
        <template #imageData>
          <image-collect ref="imageCollectRef" :modelData="modelData" :imageData="detailInfo.imageAttachs" :imageSettingInfo="detailInfo.imageSettingInfo" :showAiResult="showAiResult" :showManualResult="showManualResult"></image-collect>
        </template>
        <!-- 案例沟通 -->
        <template #caseCommunication>
          <case-communicate ref="caseCommunicateRef" :platform="platform" :info="detailInfo"></case-communicate>
        </template>
        <!-- 质量检测 -->
        <template #inspection>
          <inspection :qualityFiles="detailInfo.qualityFiles"></inspection>
        </template>
        <!-- 数据下载 -->
        <template #dataDownload>
          <dataDownload ref="dataDownloadRef" :platform="platform"></dataDownload>
        </template>
      </xl-tabs>
      <div class="tab-right">
        <div class="icon" @click="handleRefresh">
          <img src="../../../assets/image/refresh.svg" alt=""/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, defineProps, provide, nextTick } from "vue";
import {
  XlButton,
  XlSwitch,
  XlDivider,
  XlIcon,
  XlTabs,
  XlTag,
  XlMessage
} from "@shining3d/ui-components";
import { User } from "@shining3d/icons-vue";
import caseDetail from "./caseDetail.vue";
import inspection from "./inspection.vue";
import dataDownload from "./dataDownload.vue";
import imageCollect from './imageCollect.vue';
import caseCommunicate from './caseCommunicate.vue';
import _get from 'lodash/get';
import qs from 'qs';
import router from '@/router';
import { useRoute, useRouter } from 'vue-router';
import { useLang } from "@shining3d/common-module/utils/lang.js";
import { $getCdnUrl, transModelList } from '../../../utils/common.js';
import { orderDetail } from '../../../api/orderDetail/index.js';
import store from '@/store';
import { VueCookieNext } from 'vue-cookie-next';
import { transferState } from '../const.js';
const { $t } = useLang("@shining3d/xl-design-order");

const props = defineProps({
  platform: {
    type: String,
    default: 'dental'
  }
})
const curTransferState = computed(()=> props.platform === 'designerService' ?  transferState.find(item => item.value === detailInfo.value.state) || { } : {})
const Api = orderDetail[props.platform]
// const router = useRouter();
// const route = useRoute();
const route = router.currentRoute.value;
const activeTab = ref('');
const tabList = ref([
  { label: $t('design.orderDetail.caseDetail') || '案例详情', name: "caseDetail", lazy: true },
  { label: $t('design.orderDetail.imageData') || '影像数据', name: "imageData" },
  // { label: $t('design.orderDetail.caseCommunication') || '案例沟通', name: "caseCommunication", lazy: true },
  // { label: $t('design.orderDetail.inspection') || '质量检测', name: "inspection", lazy: true },
  { label: $t('design.orderDetail.dataDownload') || '数据下载', name: "dataDownload", lazy: true },
]);
const target = computed(() => _get( route, 'params.target', '' ));

const orgID = computed(() => _get( store, 'state.factorySelect.id', ''));
const orderID = computed(() => _get( route, 'params.id', '' ));

const detailInfo = ref({});
const imageUrl = ref('');

const getUrlQuery = () =>{
	const oq = window.location.search;
	if ( oq ) {
		return qs.parse( oq.slice( 1 ));
	} else {
		return {};
	}
}
const changeUrl = ( query = {}, flag = true ) => {
		const oldQuery = getUrlQuery();
		let str = '';
		if ( Object.keys( query ).length ) {
			if ( oldQuery && !flag ) {
				str = '?' + qs.stringify({ ...oldQuery, ...query });
			} else {
				str = '?' + qs.stringify( query );
			}
		}
		window.history.replaceState(
			{ path: window.location.href },
			'',
			window.location.origin + window.location.pathname + str
		);
	};
const handleClick = ( val ) => {
  router.replace({ query: { ...route.query, type: activeTab.value }, params: { ...route.params }});
  // changeUrl({ type: activeTab.value });
};

// 返回
const handleBack = () => {
  if ( props.platform !== 'dental' ) {
    router.go( -1 );
  } else {
    router.push({name: 'designOrder'})
  }
  // router.go(-1);
}
const imageCollectRef = ref();
const modelData = ref([])
const showAiResult = ref( false );
const showManualResult = ref( false );
const aiFiles = ref([]);
const manualFiles = ref([]);
const toothNumCheck = (data) => {
  // 有符合规则的牙号就强制变更为上下颚
  // FDI牙号，考虑乳牙牙号
  if ( data.toothNum) {
    if( (data.toothNum > 30 && data.toothNum < 60) || data.toothNum > 70 ) { 
      data.detailType = 'lowerJaw';
    } else {
      data.detailType = 'upperJaw';
    }
  }
  return data
}
const getDetail = (operate) => {
  modelData.value = [];
  const params = {
    orgID: orgID.value,
    orderID: orderID.value,
    lang: VueCookieNext.getCookie('lang')
  }
  Api.designOrderInfo( params ).then( res => {
    if ( res && res.status === 'success' ) {
      detailInfo.value = res.result || {};
      imageUrl.value = res.result?.orderImage ? $getCdnUrl(res.result?.orderImage) : '';
      if ( !detailInfo.value.aiOrder ) {
        tabList.value = [
          { label: $t('design.orderDetail.caseDetail') || '案例详情', name: "caseDetail", lazy: true },
          { label: $t('design.orderDetail.imageData') || '影像数据', name: "imageData" },
          { label: $t('design.orderDetail.caseCommunication') || '案例沟通', name: "caseCommunication", lazy: true },
          { label: $t('design.orderDetail.inspection') || '质量检测', name: "inspection", lazy: true },
          { label: $t('design.orderDetail.dataDownload') || '数据下载', name: "dataDownload", lazy: true },
        ];
      }
      if( operate ){
        XlMessage({ type: "success", message: $t("design.refreshSuccess") || "刷新成功" });
      }
      nextTick(() => {
        // 设计结果文件
        manualFiles.value = transModelList(res.result?.designAttachs || []).map(item=> {
          item.resultType = 'manual';
          item.attachTip =  $t('design.designResult.file') || '设计结果'
          item.feModelFileType = 'designResult'
          item = toothNumCheck(item)
          return item
        })
        // 原始文件
        const originFiles = transModelList(res.result?.attachs || []).map(item=> {
          item.resultType = 'origin';
          return item
        }); 

         aiFiles.value = transModelList(res.result?.aiDesignAttachs || []).map(item=> {
          item.resultType = 'ai';
          item = toothNumCheck(item);
          switch (item.detailType) {
            case 'upperJaw':
              item.attachTip = $t('design.toothUpperJaw')
              break;
             case 'lowerJaw':
              item.attachTip = $t('design.toothLowerJaw')
              break;
            default:
              item.attachTip = $t('design.designResult.file')
              break;
          }
          return item
        });
        showAiResult.value = !!aiFiles.value.length;
        showManualResult.value = !!manualFiles.value.length;
        modelData.value = [...manualFiles.value, ...originFiles, ...aiFiles.value];
        imageCollectRef.value?.setDataModel(modelData.value, res.result?.designDataPreviewStaus)
      });
    }
  })
};
const caseCommunicateRef = ref();
const dataDownloadRef = ref();
// 刷新
const handleRefresh = () => {
  getDetail(activeTab.value !== 'caseCommunication' ? 'refresh' : '');
  if ( activeTab.value === 'dataDownload') {
    dataDownloadRef.value.refresh();
  } else if( activeTab.value === 'caseCommunication' )  {
    caseCommunicateRef.value.refresh();
  }
}
onMounted(() => {
  activeTab.value = route?.query?.type ? route.query.type : 'caseDetail';
  handleClick();
  // 获取订单详情
  getDetail();
});
provide( 'getDetail', getDetail );
</script>
<script>
export default {
	name: 'orderDetail'
}
</script>
<style lang="scss" scoped>
.order-detail {
  font-family: "Alibaba PuHuiTi 2.0";
  height: calc(100% - 32px);
  margin: 16px;
  .order-detail-wrapper {
    height: 78px;
    padding: 12px 24px;
    box-sizing: border-box;
    border-radius: 6px;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .order-info {
      display: flex;
      .order-info-box {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
      .order-title {
        display: flex;
        align-items: center;
        .info-box {
          display: flex;
          align-items: center;
        }
        .info-text {
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          margin-left: 4px;
          color: #737e99;
          .text-color {
            color: #42526e;
          }
        }
        .xl-icon {
          margin-left: 24px;
        }
        .case-text {
          font-size: 18px;
          font-weight: 700;
          line-height: 26px;
          margin-right: 8px;
          color: #2c364e;
        }
        .order-status {
          height: 18px;
          padding: 1px 6px 1px 6px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
        }
        .blue-color{
          background: #edf3ff;
          color: #5587ff;
        }
        .red-color{
          background: #FDEEEE;
          color: #E64C4C;
        }
        .green-color{
          background: #E7F9F3;
          color: #0FBD81;
        }
        .gray-color{
          background: #EFF1F7;
          color: #42526E;
        }
        .user-icon{
          margin-left: 24px;
        }
      }
      .order-img {
        margin: 0 16px 0 24px;
        width: 81px;
        border: 1px solid #E0E4EA;
        border-radius: 2px;
        height: 54px;
        box-sizing: border-box;
      }
    }
    .back-icon {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
  .title-left {
    display: flex;
    align-items: center;
    .title-text {
      padding-left: 8px;
      font-size: 18px;
      font-weight: 700;
      line-height: 26px;
      color: #2c364e;
      cursor: pointer;
    }
  }
  .title-right {
    .chat-icon {
      margin-right: 16px;
    }
  }
  .order-detail-main {
    height: calc(100% - 96px);
    position: relative;
    border-radius: 6px;
    margin-top: 16px;
    background: #ffffff;
    .info-tabs {
      height: 100%;
    }
  }
  :deep(.el-tabs__header) {
    margin: 0 !important;
  }
  :deep(.xl-tabs .el-tabs__content) {
    padding: 0 !important;
    height: calc(100% - 46px);
    position: inherit;
    .el-tab-pane {
      height: 100%;
    }
  }
  .tab-right{
    position: absolute;
    right: 16px;
    top: 11px;
    cursor: pointer;
  }
  .icon{
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 4px;
    border-radius: 6px;
    &:hover{
      background: #F7F8FA;
    }
  }
}
</style>
